import { defineStore } from 'pinia';
import initialState from './state.js';
import actions from './actions.js';
import getters from './getters.js';

export const useAccountStore = defineStore('accounts', {
    state: () => initialState,
    getters,
    actions,
});
